import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { ContractsState } from './types';
import { RootState } from '@/types';

export const state: ContractsState = {
    data: {
      data: [],
      links: {},
      metadata: {},
    },
    loading: true,
    error: false,
};

const namespaced: boolean = true;

export const contracts: Module<ContractsState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
